export default __webpack_public_path__ + "static/media/marketplace1.a1027858.jpg";